import { render, staticRenderFns } from "./IIIFImage.vue?vue&type=template&id=87828ecc&scoped=true&"
import script from "./IIIFImage.vue?vue&type=script&lang=ts&"
export * from "./IIIFImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87828ecc",
  null
  
)

export default component.exports